// document.service.ts
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataserviceService } from '../dataservice.service';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DocumentService {
  baseUrl = environment.baseUrl;

  constructor(private http: HttpClient, private dataService: DataserviceService) {}

  markDocumentAsSigned(documentId: string): Observable<any> {
    const templateId = parseInt(documentId, 10); // Convert to number
    if (isNaN(templateId)) {
      throw new Error(`Invalid documentId: ${documentId}`);
    }

    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.dataService.getAuthToken()}`);

    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const userId = user.id;

    return this.http.post(
      `${this.baseUrl}user-template-signatures/mark-signed`,
      { userId, documentId: templateId }, // Pass the numeric ID
      { headers }
    );
  }

  getDocument(): any | null {
    const storedDoc = sessionStorage.getItem('currentDocument');
    const storedDocId = sessionStorage.getItem('currentDocumentId');
    return { document: storedDoc, documentId: storedDocId };
  }

  saveTemplate(templateData: any): Observable<any> {
    const headers = new HttpHeaders().set('Content-type', 'application/json').set('Authorization', `Bearer ` + this.dataService.getAuthToken());
    return this.http.post(`${this.baseUrl}templates`, templateData, { headers: headers });
  }

  getDocuments(): Observable<any[]> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${this.dataService.getAuthToken()}`);
    return this.http.get<any[]>(`${this.baseUrl}templates`, { headers });
  }
}
